<template>
  <div class="">
    <div class="card">
      <validationObserver ref="addDataForm" tag="form">
        <form>
          <div class="card-body">
            <h4 class="card-title mb-3">Valid OAuth Redirect URIs</h4>
            <div class="row col-lg-12">
              <div class="col-12">
                <div
                  v-for="(data, index) in componentModel.validRedirectURIs"
                  :key="index"
                  class="inner mb-3 row"
                >
                  <div class="col-md-8 col-4">
                    <validationProvider
                      :vid="`validRedirecUri_${index}`"
                      v-slot="{ errors }"
                      name="Valid OAuth Redirect URI"
                      :rules="{
                        required: true,
                        url: true,
                      }"
                    >
                      <input
                        v-model="data.uri"
                        type="text"
                        class="inner form-control"
                        placeholder="Enter URI"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid': !(errors && errors.length) && data.uri,
                        }"
                      />
                      <div
                        v-if="errors && errors.length"
                        class="invalid-feedback"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                  <div class="col-md-2 col-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteUri(index)"
                    >
                      <i class="bx bx-trash" />Delete
                    </button>
                  </div>
                </div>
                <input
                  type="button"
                  class="btn btn-sm btn-success inner"
                  value="Add more URI"
                  @click="addUri"
                />
              </div>
            </div>
          </div>
        </form>
      </validationObserver>
    </div>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title mb-3">Channel Allows</h4>
        <div class="row col-lg-12">
          <div class="col-12">
            <h4 class="card-title">Basic</h4>
            <b-form>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    label="AD"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.Basic.AD"
                      type-bold="false"
                      color="warning"
                      class="ml-1 mb-0 mt-2 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    label="Phone"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.Basic.Phone"
                      type-bold="false"
                      color="primary"
                      class="ml-1 mb-0 mt-2 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    label="Email"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.Basic.Email"
                      type-bold="false"
                      color="success"
                      class="ml-1 mb-0 mt-2 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
              </div>
            </b-form>

            <p></p>
            <h4 class="card-title">OAuth</h4>
            <b-form>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    label="Facebook"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.OAuth.Facebook"
                      type-bold="true"
                      color="info"
                      class="ml-1 mb-0 mt-2 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                    label="Google"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.OAuth.Google"
                      type-bold="false"
                      color="danger"
                      class="ml-1 mb-0 mt-2 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
              </div>
            </b-form>

            <p></p>
            <h4 class="card-title">Apps</h4>
            <b-form>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                    label="Client Apps"
                    label-for="horizontal-firstname-input"
                    label-cols-sm="4"
                  >
                    <switches
                      v-model="componentModel.channelAllows.Apps.ClientApps"
                      type-bold="true"
                      color="secondary"
                      class="mb-0 switches-channel"
                    ></switches>
                  </b-form-group>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Switches from "vue-switches";

export default {
  name: "oauth_component",
  components: { Switches },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.componentModel;
      },
    },
    isChanged: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    app_client_id: {
      type: String,
      default: () => {
        return "";
      },
    },
    tech_product_id: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      componentModel: {
        validRedirectURIs: [],
        channelAllows: {
          OAuth: {
            Facebook: false,
            Google: false,
          },
          Basic: {
            AD: true,
            Phone: false,
            Email: false,
          },
          Apps: {
            ClientApps: false,
          },
        },
      },
      componentModelOriginal: {},
      isValidate: {
        status: false,
      },
    };
  },
  created: function () {
    if (this.value) {
      this.componentModel = this.value;
      this.componentModelOriginal = JSON.parse(JSON.stringify(this.value));
    }
  },
  watch: {
    value: {
      handler(val) {
        this.componentModel = val;
      },
      deep: true,
    },
    componentModel: {
      handler(val) {
        if (this.componentModelOriginal) {
          if (
            JSON.stringify(this.componentModel) !==
            JSON.stringify(this.componentModelOriginal)
          )
            this.$emit("update:isChanged", true);
          else this.$emit("update:isChanged", false);
        }
      },
      deep: true,
    },
  },
  methods: {
    async onPageLoaded() {},

    addUri() {
      let _id = this.componentModel.validRedirectURIs.length + 1;
      this.componentModel.validRedirectURIs.push({ id: _id, uri: "" });
    },
    deleteUri(index) {
      this.componentModel.validRedirectURIs.splice(index, 1);
    },
  },
};
</script>
